import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.958 5.958a2 2 0 0 1 2-2h8.084a2 2 0 0 1 2 2v6.417a2 2 0 0 1-2 2h-1.854L10 16.042l-2.188-1.667H5.958a2 2 0 0 1-2-2V5.958Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M7.917 9.167a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm2.5 0a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Zm2.5 0a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);